var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormComponent as _FormComponent, } from './angular2-schema-form-shim';
import { useFactory } from './formpropertyfactory';
import { FormElementComponent } from './formelement.component';
var ɵ0 = useFactory;
var FormComponent = (function (_super) {
    __extends(FormComponent, _super);
    function FormComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toast = null;
        return _this;
    }
    return FormComponent;
}(_FormComponent));
export { FormComponent };
export { ɵ0 };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/form.component.ts.pre-build-optimizer.js